
let cache = {}
let cacheTime = 60 * 1000

export default {
  methods: {
    _getSaleableProductsShipping() {
      return this.$http.post('sales/shippingitems', {  }, this.completeHttpParams({})).then(response => response.body)
    },
    _getSaleableProducts({ productTypes }) {
      return this.$http.post('sales/saleableitems', { productTypes, mediaType: 'ETicket' }, this.completeHttpParams({})).then(response => response.body)
    },
    _getSaleableProductsCSC({ productTypes, mediaSerialNumber, mediaUnicity }) {
      return this.$http.post('sales/saleableitems', { productTypes, mediaType: 'Csc', mediaSerialNumber, mediaUnicity }, this.completeHttpParams({})).then(response => response.body)
    },
    _getSaleableProductsOnCSC({ mediaSerialNumber, mediaUnicity }) {
      return this.$http.post('sales/saleableitemscsc', { mediaSerialNumber: mediaSerialNumber, mediaUnicity }, this.completeHttpParams({})).then(response => {
        if (response.ok && response.body && response.body.length) {
          response.body.forEach(pr => {
            let key = `${pr.Id}_TransportProduct_0`
            console.log('saving', key)
            cache[key] = { _tm: (new Date()).getTime(), ...pr }
          })
        }
        return response.body
      })
    },
    _getSaleableItem ({ itemId, mediaType, mediaSerialNumber, mediaUnicity, index }) {
      let key = `${itemId}_${mediaType}_${index}`
      console.log('searching', key)
      if (cache[key]) {
        if ((new Date()).getTime() - cache[key]._tm < cacheTime) {
          return new Promise(resolve => {
            setTimeout(() => {
              resolve(cache[key])
            }, 100)
          })
        } else {
          delete cache[key]
        }
      }
      return this.$http.post('sales/saleableitemdetails', { itemId, mediaType, mediaSerialNumber: mediaSerialNumber || '', mediaUnicity: mediaUnicity || '', index: index || 0 }, this.completeHttpParams({})).then(response => {
        cache[key] = { _tm: (new Date()).getTime(), ...response.body }
        return response.body
      })
    },
    _getOrigins (ItemInfo, MediaSerialNumber, MediaUnicity) {
      return this.$http.post('sales/origins', { MediaSerialNumber, MediaUnicity, ItemInfo, MediaType: ItemInfo.MediaType }, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _getDestinations (ItemInfo, MediaSerialNumber, MediaUnicity) {
      return this.$http.post('sales/travels', { MediaSerialNumber, MediaUnicity, ItemInfo, MediaType: ItemInfo.MediaType }, this.completeHttpParams({ emulateJSON: false })).then(response => response.body.map(d => { return { ...d.Destination, ApisToCall: d.ApisToCall, original: d,
                                          subtitle: (d.Via && d.Viabis ? `${d.Via.Label} - ${d.Viabis.Label}` : (d.Via ? d.Via.Label : (d.Viabis && d.Viabis.Label || null))) } }))
    },
    _getLuggageVehicleWeightInfos (ItemInfo, MediaSerialNumber, MediaUnicity) {
      return this.$http.post('sales/luggagevehicleweightinfos', { MediaSerialNumber, MediaUnicity, ItemInfo, MediaType: ItemInfo.MediaType }, this.completeHttpParams({ emulateJSON: false })).then(response => response.body.map(d => { return { Id: d.FareIndex, Label: d.Description, ApisToCall: d.ApisToCall, original: d } }))
    },
    /* _getVias () {
      let lst = []
      let max = 2 + Math.random() * 2
      for (let i = 0; i < max; i++) {
        lst.push(Math.random() > 0.25 ? 'Via ' + (i + 1) : { title: 'Via ' + (i + 1), subtitle: 'Sottotitolo' })
      }
      return Promise.resolve(lst)
    }, */
    _getPrice (ItemInfo, MediaSerialNumber, MediaUnicity) {
      return this.$http.post('sales/calculateitemprice', { MediaSerialNumber, MediaUnicity, ItemInfo, MediaType: ItemInfo.MediaType, UserCode: this.user.UserAccountCode }, this.completeHttpParams({ emulateJSON: false })).then(response =>  response.body)
    },

    _getEvidences (OrderId, orderItemIds ) {
      return this.$http.get('sales/evidence', this.completeHttpParams({ headers: {
        orderId: '' + OrderId,
        orderItemIds: '' +orderItemIds,
        UserCode: this.user.UserAccountCode    
      }})).then(response => response.body)
    },
    _postEvidences (OrderId, orderItemId,evidences ) { 
      return this.$http.post('sales/evidence',JSON.stringify(evidences), this.completeHttpParams({ headers: {
        orderId: '' + OrderId,
        orderItemId: '' +orderItemId,
        documentEvidenceId:''+0,
        UserCode: this.user.UserAccountCode    
      }},
    )).then(response => {
        return response.body
      })
    },

    _getReceipt (orderId,orderDate) {
      return this.$http.get('sales/receipt/'+orderDate+'/'+orderId, this.completeHttpParams({ headers: {  UserCode: this.user.UserAccountCode}, emulateJSON: false,responseType: 'arraybuffer' })).then(response =>  response.body)
    }

  }
}